<template>
  <!-- 富文本 -->
  <div class="box">
    <div class="contract-title">{{ text }}</div>
    <div class="wenben">
      <quill-editor
        ref="myQuillEditor"
        v-model="content"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @ready="onEditorReady($event)"
        @change="onEditorChange($event)"
      />
    </div>
    <div>
      <label class="container">
        I have read and agree
        <input type="checkbox" v-model="checked" />
        <span class="checkmark"></span>
      </label>
    </div>
    <el-button class="ppp" type="primary" @click="signout()">recognize</el-button>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import axios from "axios";
export default {
  components: {
    quillEditor
  },
  data() {
    return {
      checked: false,
      text: "Policy Conditions",
      content:
        "<p>Name of the borrower:{borrower}<p> ID Number: { ID number} Mobile Number: {mobile number} Loan Amount: {Loan amount} Installment Payment:{Loan term} Beneficiary Bank Name:{Beneficiary Bank} “Instal l ment Agreement”, The Lender And The Borrower Agree To And Jointly Abide By This Agreement. Adhering To The Principles Of Equity, Voluntary, Honesty And Reputation, There Is No Consensus, This Small Loan Agreement Is" // 文本内容
    };
  },
  methods: {
    // 失去焦点事件
    onEditorBlur() {},
    // 获得焦点事件
    onEditorFocus(event) {
      event.enable(false);
    },
    // 准备编辑器
    onEditorReady() {},
    // 内容改变事件
    onEditorChange() {},
    signout() {
      if (this.checked) {
        this.$router.go(-1);
      } else {
        this.$message.error("Please read carefully and agree to check!");
      }
    },
    //返回上一个页面
    getRepayment() {
      this.$router.push("/myloan");
    },
    //接口函数
    getConstractInf() {
      axios
        .get(
          `/agreement/agreement/selectpolicy`,
          {
            uid: sessionStorage.getItem("token")
          },
          {
            withCredentials: true
          }
        )
        .then(res => {
          this.content = res.data.data.systext;
         ////console.log(res.data.data);
        })
        .catch(() => {});
    }
  },
  watch: {
    // 监听文本变化内容
    content() {
      // ////console.log(this.content);
    }
  },
  mounted() {
    this.$refs.myQuillEditor.quill.disable();
    this.getConstractInf();
    const header = document.querySelector(".ql-toolbar");
    header.style.display = "none";
  }
};
</script>

<style scoped>
.xybox {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
}
.xytitle {
  width: 90%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
p {
  width: 100%;
  font-size: 38px;
}
.xy {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #bbbbbb;
  padding: 5px;
}
.chbox {
  width: 100%;
  height: 100px;
}
.el-checkbox__inner {
  width: 100px;
  height: 100px;
}
/* 容器 */
.container {
  display: unset;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-top: 10px;
}
.quill-editor   {
  caret-color: transparent;
}

/* 隐藏浏览器的默认复选框 */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* 创建自定义复选框 */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* 在鼠标悬停时，添加灰色背景色 */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* 当复选框被选中时，添加一个蓝色背景 */
.container input:checked ~ .checkmark {
  background-color: #a95159;
}

/* 创建复选标记/指示器（未选中时隐藏）*/
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* 选中时显示复选标记 */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* 设置复选标记/指示器的样式 */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.ppp {
  margin-top: 10px;
  padding: 10px 80px;
  font-size: 30px;
  background: #a95159;
}
.english {
  width: 90%;
  display: flex;
  justify-content: right;
  position: absolute;
  left: 35px;
  top: 85px;
}
.english {
  width: 90%;
  display: flex;
  justify-content: right;
  position: absolute;
  left: 20px;
  top: 95px;
}
.but {
  padding: 5px 10px;
}
.box {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.wenben {
  padding: 1%;
  margin-top: 20px;
}
.contract-title {
  z-index: 99;
  position: fixed;
  left: 0;
  top: 0;
  color: #fff;
  height: 70px;
  line-height: 70px;
  text-align: center;
  background: linear-gradient(183deg, #a95159, #a95159);
  width: 100%;
  font-size: 30px;
  position: relative;
}
</style>

